module.exports = __webpack_public_path__ + "img/ic_success_order-completed.1a5c8c0.svg";